module.exports = __webpack_public_path__ + "img/email_avatar.b0213801.svg";